// Centralized company / legal contact info — edit these once and all legal pages update.
export const COMPANY = {
  brand: "RESADA",
  legalName: "RESADA",
  tagline: "Platform Lead Generation & Sales Automation Indonesia",
  website: "https://resada.id",
  app: "https://app.resada.id",
  email: "support@resada.id",
  whatsapp: "6282342302515",
  whatsappDisplay: "+62 823-4230-2515",
  address: "Jl. Wonosari Ponjong KM. 7, Karangmojo, Kelor, Kec. Karangmojo, Kabupaten Gunungkidul, Daerah Istimewa Yogyakarta 55891",
  country: "Indonesia",
  updated: "25 Juni 2026",
};

export const LEGAL_NAV = [
  { to: "/terms", label: "Syarat & Ketentuan" },
  { to: "/privacy", label: "Kebijakan Privasi" },
  { to: "/refund", label: "Pengembalian Dana" },
  { to: "/faq", label: "FAQ" },
  { to: "/kontak", label: "Kontak" },
];
